import React from 'react'
import { authRoles } from '../../auth/authRoles'

const CommonRoutes = [

    {
        path: '/payoutsMainView',
        component: React.lazy(() => import('./Payouts/PayaoutHotelList')),
        auth: authRoles.super_admin,
    },
    {
        path: '/HotelOwnerPayouts',
        component: React.lazy(() => import('./HotelOwnerPayout/All')),
        auth: authRoles.control,
    },
    {
        path: '/HotelOwnerPayoutsHistory/:id',
        component: React.lazy(() => import('./HotelOwnerPayout/Tabs/PayaoutHistorySingleView')),
        auth: authRoles.control,
    },
    {
        path: '/adminPayouts/:id',
        component: React.lazy(() => import('./Payouts/All')),
        auth: authRoles.super_admin,
    },
    

    // payout settlements

    {
        path: '/payoutsSettlements',
        component: React.lazy(() => import('./PayoutsSettlement/PayoutSettlementMain')),
        auth: authRoles.control,
    },

    // User Profiles

    {
        path: '/user_profiles',
        component: React.lazy(() => import('./User_Profile/Profile')),
        auth: authRoles.profile,
    },

    
  
]

export default CommonRoutes
